import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AbstractMapControlComponent } from '@app/shared/components/map/abstract-map-control.component';
import { AssetMapMarkerGroup } from '@app/shared/components/map/asset-map-marker-group';

@Component({
    selector: 'assets-map-makers-control',
    templateUrl: './assets-map-markers-control.component.html',
    styleUrls: ['./assets-map-markers-control.component.scss'],
    standalone: false
})
export class AssetsMapMarkersControlComponent extends AbstractMapControlComponent {
  public controlExpended: boolean = false;
  @Input() public assetMapMarkerGroups: AssetMapMarkerGroup[];
  @Input() public groupedMarkersEnable: boolean;
  @Input() public selectedMapMarkerGroup: AssetMapMarkerGroup;

  @Output() public slideToggleChange = new EventEmitter<boolean>();
  @Output() public radioAssetMapMarkerGroupChange = new EventEmitter<AssetMapMarkerGroup>();

  public onSlideToggleChange(event: MatSlideToggleChange): void {
    this.slideToggleChange.emit(event.checked);
  }

  public onMouseEnter(): void {
    this.controlExpended = true;
  }

  public onMouseLeave(): void {
    this.controlExpended = false;
  }

  /**
   * Transmit toggle event.
   * @param event Toggle event.
   */
  public onRadioChange(event: MatRadioChange): void {
    this.radioAssetMapMarkerGroupChange.emit(event.value);
  }

  /**
   * Whether the markers radio buttons should be displayed on the map. Markers should be displayed only when there are
   * more than one choice available.
   * @return True if markers should be displayed, false otherwise.
   */
  public shouldDisplayMapMarkers(): boolean {
    return this.assetMapMarkerGroups.length > 1;
  }
}
